import { render, staticRenderFns } from "./icon_management.vue?vue&type=template&id=6235104a&scoped=true"
import script from "./icon_management.vue?vue&type=script&lang=js"
export * from "./icon_management.vue?vue&type=script&lang=js"
import style0 from "./icon_management.vue?vue&type=style&index=0&id=6235104a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235104a",
  null
  
)

export default component.exports